export default function (context, value) {
    let cb = () => {
    };
    if (value) {
        if (value.cb) cb = value.cb;
    }
    let form = context.getters.form;
    axios({
        method: 'get',
        url: '/tourclient/payment/paymentCatalogsData?_=' + new Date().getTime()
    }).then(({data}) => {
        context.commit('set', {
            DocumentNumber: data.IncomePaymentNumber,
        });
        cb(data.IncomePaymentNumber);
    });
}